import {useEffect, useRef, useState} from 'react';

const Pagination = props => {
    const {maxPages, resultsPerPage, setOffset, startPage} = props;
    const [currentPage, setCurrentPage] = useState(1);
    const [showPagination, setShowPagination] = useState(false);
    const currentPageRef = useRef();

    const setPage = pageNumber => {
        const newPage = pageNumber;
        const newOffset = resultsPerPage * (newPage - 1);
        setCurrentPage(newPage);
        setOffset(newOffset);
    };

    const nextPage = () => {
        if (currentPage < maxPages) {
            setCurrentPage(currentPage + 1);
            setOffset(resultsPerPage * currentPage);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            const newPage = currentPage - 1;
            const newOffset = resultsPerPage * (newPage - 1);
            setCurrentPage(newPage);
            setOffset(newOffset);
        }
    };

    useEffect(() => {
        if (maxPages > 1) {
            setShowPagination(true);
        } else {
            setShowPagination(false);
        }
    }, [maxPages, setShowPagination]);

    useEffect(() => {
        if (startPage) {
            setCurrentPage(startPage);
        }
    }, [startPage, setCurrentPage]);

    return (
            <div className="d-flex" style={{marginTop: 15}}>
                    {showPagination && <>
                        <ul className="pagination" style={{'flexWrap': 'wrap'}}>
                            <li className={'page-item' + (maxPages > 1 && currentPage > 1 ? '' : ' disabled ')}>
                                <button className="page-link" aria-label="Previous" onClick={prevPage}>
                                    <span aria-hidden="true">&lt;</span>
                                </button>
                            </li>

                            <li className={'page-item ' + (currentPage === 1 ? 'active' : '')}>
                                <button className="page-link" onClick={() => setPage(1)}>1</button>
                            </li>

                            {currentPage - 3 > 1 &&
                                <li className={'page-item disabled'}>
                                    <div className="page-link">...</div>
                                </li>}

                            {maxPages > 2 &&
                                Array((maxPages - 2)).fill(1).map((el, i) =>
                                    <li key={i} className={'page-item ' + (currentPage === i + 2 ? 'active' : '')}>

                                        {i + 2 < currentPage && i + 2 > currentPage - 3 &&
                                            <button className="page-link" onClick={() => setPage(i + 2)}>{i + 2}</button>}

                                        {i + 2 === currentPage &&
                                            <button className="page-link" onClick={() => setPage(i + 2)}
                                                    ref={currentPageRef}>{i + 2}</button>}

                                        {i + 2 > currentPage && i + 2 < currentPage + 3 &&
                                            <button className="page-link" onClick={() => setPage(i + 2)}>{i + 2}</button>}
                                    </li>
                                )}

                            {currentPage + 3 < maxPages &&
                                <li className={'page-item disabled'}>
                                    <div className="page-link">...</div>
                                </li>}

                            {maxPages > 1 && <li className={'page-item ' + (currentPage === maxPages ? 'active' : '')}>
                                <button className="page-link" onClick={() => setPage(maxPages)}>{maxPages}</button>
                            </li>}

                            <li className={'page-item' + (maxPages > 1 && currentPage < maxPages ? '' : ' disabled ')}>
                                <button className="page-link" aria-label="Next" onClick={nextPage}>
                                    <span aria-hidden="true">&gt;</span>
                                </button>
                            </li>
                        </ul>
                    </>}
            </div>
    );
};

export default Pagination;
